module.exports = __webpack_public_path__ + "static/media/digestive-system-diseases-icon.12e9fd6e.svg";